import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-header p-d-flex p-ai-center" }
const _hoisted_2 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Message, {
      class: "p-m-2",
      severity: "info",
      closable: false,
      style: _ctx.workspaceSchedulationOldSchedulationsTableDescriptor.styles.message
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('workspace.schedulation.oldSchedulationsMessage')), 1)
      ]),
      _: 1
    }, 8, ["style"]),
    _createVNode(_component_DataTable, {
      value: _ctx.schedulations,
      id: "old-chedulations-table",
      class: "p-datatable-sm kn-table",
      dataKey: "id",
      filters: _ctx.filters,
      "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters = $event)),
      globalFilterFields: _ctx.workspaceSchedulationOldSchedulationsTableDescriptor.globalFilterFields,
      paginator: _ctx.schedulations.length > 20,
      rows: 20,
      responsiveLayout: "stack",
      breakpoint: "600px"
    }, {
      empty: _withCtx(() => [
        _createVNode(_component_Message, {
          class: "p-m-2",
          severity: "info",
          closable: false,
          style: _ctx.workspaceSchedulationOldSchedulationsTableDescriptor.styles.message
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      header: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("span", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_InputText, {
              class: "kn-material-input",
              modelValue: _ctx.filters['global'].value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
              type: "text",
              placeholder: _ctx.$t('common.search')
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          class: "kn-truncated",
          field: "name",
          header: _ctx.$t('common.packages'),
          key: "name",
          sortable: true
        }, null, 8, ["header"]),
        _createVNode(_component_Column, {
          class: "kn-truncated",
          field: "dateCreation",
          header: _ctx.$t('common.time'),
          key: "dateCreation",
          sortable: true
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.getFormattedDate(slotProps.data.dateCreation, 'MMM DD, YYYY h:mm:ss A')), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          style: _ctx.workspaceSchedulationOldSchedulationsTableDescriptor.iconColumn.style
        }, {
          body: _withCtx((slotProps) => [
            _withDirectives(_createVNode(_component_Button, {
              icon: "pi pi-download",
              class: "p-button-link",
              onClick: ($event: any) => (_ctx.downloadSnapshot(slotProps.data))
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('common.download'),
                void 0,
                { top: true }
              ]
            ])
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      _: 1
    }, 8, ["value", "filters", "globalFilterFields", "paginator"])
  ], 64))
}